module.exports = __webpack_public_path__ + "static/media/other.35b349c8.svg";